// extracted by mini-css-extract-plugin
export default {"container":"profile_container__-6tVQ","records":"profile_records__riBey","buttons":"profile_buttons__Dwndk","button":"profile_button__6HMYQ"};